var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex text-lg py-1 border-top",
    },
    [
      _c(
        "div",
        {
          staticClass: "w-20x border-right",
        },
        [
          _c(
            "div",
            {
              staticClass: "text-center text-lg text-monospace",
            },
            [
              _vm._v("\n      " + _vm._s(_vm.item.digits) + " "),
              _c("i", {
                staticClass: "fas",
                class: _vm.iconType(_vm.item.type),
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-20x border-right",
        },
        [
          _c(
            "div",
            {
              staticClass: "text-center text-lg text-monospace",
            },
            [_vm._v("\n      " + _vm._s(_vm.item.amount) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.item.type != "4upper"
        ? _c(
            "div",
            {
              staticClass: "w-20x border-right",
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-center text-lg text-monospace",
                },
                [_vm._v("\n      " + _vm._s(_vm.item.paybaht) + "\n    ")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item.type != "4upper"
        ? _c(
            "div",
            {
              staticClass: "w-40x",
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-center text-lg text-monospace",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        Intl.NumberFormat({
                          style: "currency",
                          currency: "THB",
                        }).format(_vm.item.amount * _vm.item.paybaht)
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "w-60x",
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-center text-lg text-monospace",
                },
                [_vm._v("\n      1 ชุด\n    ")]
              ),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }